
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { initWxJSSDK, getAddressList } from '../../../common/js/api.js'
import { setCookie, getCookie } from '../../../common/js/utils.js'

export default {
components: {
XHeader,
Group,
CellBox,
Cell,
Scroller,
Box,
XButton
},
data() {
return {
title: '使用说明',
platform: '',
list: []
}
},
methods: {
getAddressList() {
let self = this
getAddressList().then(function(data) {
self.list = data.Content
})
},
editAddress(idx) {
this.$router.push({
path: '/BirdAddressEdit',
query: { recordId: this.list[idx].recordID }
})
},
clickAddress(idx) {
this.partnerId = this.$route.query.partnerId
self.platform = this.$config.platform
let path = '/BirdAppointment'
if (this.$route.query.type == 'choice') {
if (this.$route.query.from == 'shop') {
this.$wechat.miniProgram.navigateBack({ delta: 1 })
} else {
this.$router.push({
path: path,
query: {
addressId: this.list[idx].recordID,
areaCode: this.list[idx].areaCode,
partnerId: this.partnerId,
addressText: escape(
this.list[idx].areaCodeText + this.list[idx].address
)
}
})
}
} else {
this.$router.push({
path: '/BirdAddressEdit',
query: {
recordId: this.list[idx].recordID,
from: this.$route.query.from
}
})
}
}
},
created() {


},
mounted() {
console.log('mounted')








},
activated() {

this.getAddressList();
initWxJSSDK()

},
deactivated() {


}
}



// WEBPACK FOOTER //
// ./src/components/activity/bird/AddressList.vue